import type { SVGProps } from 'react';

/**
 * YouTube's branding guidelines forbid altering, recoloring, or boxing this icon and require it to render at
 * least 20px tall, so size it by height wherever it appears.
 */
export const YouTubeLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 313.23315 216.02286" {...props}>
    <title>YouTube</title>
    <g transform="translate(-54.079375,-5.2758072)">
      <path
        fill="#ff0033"
        d="m 210.53177,221.29866 c 0,0 98.12514,0 122.46443,-6.48069 13.70449,-3.6724 24.01093,-14.2575 27.62825,-27.32688 6.68807,-23.97854 6.68807,-74.41988 6.68807,-74.41988 0,0 0,-50.117297 -6.68807,-73.879819 C 357.00713,25.79798 346.70069,15.42887 332.9962,11.864515 308.65691,5.2758072 210.53177,5.2758072 210.53177,5.2758072 c 0,0 -97.9062,0 -122.135976,6.5887078 -13.485335,3.564355 -24.010529,13.933465 -27.847831,27.326876 -6.468588,23.762522 -6.468588,73.879819 -6.468588,73.879819 0,0 0,50.44134 6.468588,74.41988 3.837302,13.06938 14.362496,23.65448 27.847831,27.32688 24.229776,6.48069 122.135976,6.48069 122.135976,6.48069 z"
      />
      <path fill="#ffffff" d="M 259.30109,113.28723 178.29251,67.382379 v 91.809711 z" />
    </g>
  </svg>
);
